import React, { Component } from 'react';

export class SublocationContents extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const viewItemInfoFunction = this.props.viewItemInfo;
        const sublocationContents = this.props.sublocationContents;
        let parentWNoItems = true;
        // First, group items by sublocation
        const groupedBySublocation = {};
        for (const i in sublocationContents) {
            const item = sublocationContents[i];
            // Use item.sublocation as the key (or fallback to "Unknown")
            const sublocation = item.sublocation || "Unknown";
            if (sublocation == this.props.sublocationId) {
                parentWNoItems = false;
            }
            if (!groupedBySublocation[sublocation]) {
                groupedBySublocation[sublocation] = [];
            }
            groupedBySublocation[sublocation].push(item);
        }

        return (
            <>
                {
                    parentWNoItems &&
                    <>
                        <h3>{this.props.sublocationName}</h3>
                        {this.props.sublocationImageURL && (
                            <>
                                <br />
                                <img
                                    src={this.props.sublocationImageUR}
                                    onClick={e => {
                                        this.props.viewImage(e, this.props.sublocationName, this.props.sublocationImageURL);
                                    }}
                                    alt={this.props.sublocationName}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                            </>
                        )}
                        <br/>
                    </>
                }
                {Object.keys(groupedBySublocation).map(sublocationKey => {
                    const itemsForSublocation = groupedBySublocation[sublocationKey];
                    const sublocationImageURL = itemsForSublocation[0].sublocationImageURL;
                    // Now group items within this sublocation by parent (as before)
                    let itemsGroupedByParent = {};
                    for (const i in itemsForSublocation) {
                        const item = itemsForSublocation[i];
                        const parent = item.parent || item.itemid;
                        if (!itemsGroupedByParent[parent]) {
                            itemsGroupedByParent[parent] = {
                                key: parent,
                                name: item.parentname || item.displayname,
                                items: [],
                                colors: [],
                                sizes: [],
                                image: item.imageUrls[0]
                            };
                        }
                        itemsGroupedByParent[parent].items.push(item);
                        if (item.color && itemsGroupedByParent[parent].colors.indexOf(item.color) === -1) {
                            itemsGroupedByParent[parent].colors.push(item.color);
                        }
                        if (item.size && itemsGroupedByParent[parent].sizes.indexOf(item.size) === -1) {
                            itemsGroupedByParent[parent].sizes.push(item.size);
                        }
                    }

                    return (
                        <div key={sublocationKey} style={{ marginBottom: '2em' }}>
                            <b>{sublocationKey}</b>
                            {sublocationImageURL && (
                                <>
                                    <br />
                                    <img
                                        src={sublocationImageURL}
                                        onClick={e => {
                                            this.props.viewImage(e, sublocationKey, sublocationImageURL);
                                        }}
                                        alt={sublocationKey}
                                        style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                    />
                                </>
                            )}
                            <div>
                                <table
                                    className="sublocation-contents sublocation-table table"
                                    aria-labelledby="tableLabel"
                                    onClick={e => e.preventDefault()}
                                >
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Summary</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(itemsGroupedByParent).map(parent => {
                                            const itemGroup = itemsGroupedByParent[parent];
                                            return (
                                                <tr key={parent}>
                                                    <td>
                                                        <img
                                                            src={itemGroup.image}
                                                            onClick={e => {
                                                                this.props.viewImage(e, itemGroup.name, itemGroup.image);
                                                            }}
                                                            alt={itemGroup.name}
                                                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                        />
                                                    </td>
                                                    <td onClick={e => viewItemInfoFunction(e, itemGroup)}>
                                                        <div>{itemGroup.name}</div>
                                                        {itemGroup.colors.length > 0 && (
                                                            <div>Colors: {itemGroup.colors.join(', ')}</div>
                                                        )}
                                                        {itemGroup.sizes.length > 0 && (
                                                            <div>Sizes: {itemGroup.sizes.join(', ')}</div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    }
}
